import { Box, styled } from '@mui/material';

export const IdmCard = styled(Box)(({ theme }) => ({
  borderRadius: 12,
  padding: theme.spacing(6),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(3),
  backgroundColor: theme.palette.primaries[600],
  width: '100%',
}));
